/* eslint-disable no-restricted-syntax */
// const Flickity = require('flickity');
import Flickity from 'flickity';
// const mediaBreakPoint = '(max-width: 1023px)';
// const mq = window.matchMedia(mediaBreakPoint);
const bodyElement = document.querySelector('body');
const isInViewport = (element) => {
	const rect = element.getBoundingClientRect();
	return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

class Accordion {
	constructor(accordion, animationPanel) {
		this.accordion = accordion;
		this.animationPanel = animationPanel || false;
		this.allExpanded = false;

		this.allowMultiple = this.accordion.hasAttribute('data-allow-multiple');
		this.allowToggle = this.allowMultiple ? this.allowMultiple : this.accordion.hasAttribute('data-allow-toggle');

		this.triggers = this.accordion.querySelectorAll('.accordion-trigger:not(.always-open)');
		this.closeEls = this.accordion.querySelectorAll('.close-accordion');
		this.panels = this.accordion.querySelectorAll('.accordion-panel');

		if (!this.allowToggle) {
			const expanded = this.accordion.querySelector('[aria-expanded="true"]');

			if (expanded) {
				expanded.setAttribute('aria-disabled', 'true');
			}
		}
	}

	init() {
		for (const trigger of this.triggers) {
			trigger.addEventListener('click', this.handleClick.bind(this));
			trigger.addEventListener('keydown', this.handleKeydown.bind(this));
			trigger.addEventListener('focus', this.handleControllerFocus.bind(this));
			trigger.addEventListener('blur', this.handleControllerBlur.bind(this));
		}
		for (const closeEl of this.closeEls) {
			closeEl.addEventListener('click', this.handleCloseClick.bind(this));
		}
	}

	handleClick(event) {
		const target = event.currentTarget;

		if (target.classList.contains('accordion-trigger')) {
			event.preventDefault();
			event.stopPropagation();

			const isExpanded = target.getAttribute('aria-expanded') === 'true';
			const active = this.accordion.querySelector('[aria-expanded="true"]');

			if (!this.allowMultiple && active && active !== target) {
				active.setAttribute('aria-expanded', 'false');
				const activedPanel = this.accordion.querySelector(`#${active.getAttribute('aria-controls')}`);
				if (this.animationPanel) {
					activedPanel.style.height = 0;
					activedPanel.classList.add('hidden');
				}
				activedPanel.setAttribute('hidden', '');
				activedPanel.setAttribute('aria-hidden', 'true');

				if (!this.allowToggle) {
					active.removeAttribute('aria-disabled');
				}
			}

			if (!isExpanded) {
				target.setAttribute('aria-expanded', 'true');

				const targetAccordionPanel = this.accordion.querySelector(`#${target.getAttribute('aria-controls')}`);
				if (this.animationPanel) {
					targetAccordionPanel.style.height = `${targetAccordionPanel.scrollHeight}px`;
					targetAccordionPanel.classList.remove('hidden');
				}
				targetAccordionPanel.removeAttribute('hidden');
				targetAccordionPanel.removeAttribute('aria-hidden');

				if (targetAccordionPanel.querySelector('.gallery-carousel')) {
					const gCarouselEls = targetAccordionPanel.querySelector('.gallery-carousel');
					const gCarouselFlickity = Flickity.data(gCarouselEls);
					gCarouselFlickity.resize();
				}

				if (targetAccordionPanel.querySelector('.image-text-carousel')) {
					const itCarouselEl = targetAccordionPanel.querySelector('.image-text-carousel');
					const itCarouselFlickity = Flickity.data(itCarouselEl);
					itCarouselFlickity.resize();
				}

				if (!isInViewport(target)) {
					const windowPageYOffset = window.pageYOffset - (bodyElement.classList.contains('scrolling') ? 220 : 160);
					const elemDistanceToTop = windowPageYOffset + target.getBoundingClientRect().top;
					window.scrollTo(0, elemDistanceToTop);
				}

				if (!this.allowToggle) {
					target.setAttribute('aria-disabled', 'true');
				}
			} else if (this.allowToggle && isExpanded) {
				target.setAttribute('aria-expanded', 'false');
				const targetdPanel = this.accordion.querySelector(`#${target.getAttribute('aria-controls')}`);
				if (this.animationPanel) {
					targetdPanel.style.height = `${0}px`;
					targetdPanel.classList.add('hidden');
				}
				targetdPanel.setAttribute('hidden', '');
				targetdPanel.setAttribute('aria-hidden', 'true');
			}
		}

		if (target.getAttribute('id') === 'opentimeID') {
			target.remove();
		}
	}

	handleKeydown(event) {
		const target = event.currentTarget;
		const key = event.which.toString();
		// 33 = Page Up, 34 = Page Down
		const ctrlModifier = event.ctrlKey && key.match(/33|34/);

		if (target.classList.contains('accordion-trigger')) {
			// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
			// 38 = Up, 40 = Down
			if (key.match(/38|40/) || ctrlModifier) {
				const index = this.triggers.indexOf(target);
				const direction = key.match(/34|40/) ? 1 : -1;
				const { length } = this.triggers;
				const newIndex = (index + length + direction) % length;

				this.triggers[newIndex].focus();

				event.preventDefault();
			} else if (key.match(/35|36/)) {
				// 35 = End, 36 = Home keyboard operations
				switch (key) {
					// Go to first accordion
					case '36':
						this.triggers[0].focus();
						break;

					// Go to last accordion
					case '35':
						this.triggers[this.triggers.length - 1].focus();
						break;
					default:
						break;
				}
				event.preventDefault();
			}
		}
	}

	expandedAll() {
		for (const trigger of this.triggers) {
			trigger.setAttribute('aria-expanded', 'true');
			trigger.setAttribute('aria-disabled', 'true');
			trigger.disabled = true;
			const triggerAccorditionPanel = this.accordion.querySelector(`#${trigger.getAttribute('aria-controls')}`);
			if (this.animationPanel) {
				triggerAccorditionPanel.style.height = triggerAccorditionPanel.offsetHeight;
				triggerAccorditionPanel.classList.remove('hidden');
			}
			triggerAccorditionPanel.removeAttribute('hidden');
			triggerAccorditionPanel.removeAttribute('aria-hidden');
		}
		this.allExpanded = true;
	}

	deactivateAll() {
		for (const trigger of this.triggers) {
			trigger.setAttribute('aria-expanded', 'false');
			trigger.setAttribute('aria-disabled', 'false');
			trigger.disabled = false;
			const triggerAccorditionPanel = this.accordion.querySelector(`#${trigger.getAttribute('aria-controls')}`);
			if (this.animationPanel) {
				triggerAccorditionPanel.style.height = `${0}px`;
				triggerAccorditionPanel.classList.add('hidden');
			}
			triggerAccorditionPanel.setAttribute('hidden', '');
			triggerAccorditionPanel.setAttribute('aria-hidden', 'true');
		}
	}

	// eslint-disable-next-line no-unused-vars
	handleControllerFocus(event) {
		this.accordion.classList.add('focus');
	}

	// eslint-disable-next-line no-unused-vars
	handleControllerBlur(event) {
		this.accordion.classList.remove('focus');
	}

	closeExpandedPanel() {
		for (const trigger of this.triggers) {
			if (trigger.getAttribute('aria-expanded') === 'true' && !trigger.classList.contains('always-open')) {
				trigger.setAttribute('aria-expanded', 'false');
				trigger.setAttribute('aria-disabled', 'false');
				trigger.disabled = false;
				const triggerAccorditionPanel = this.accordion.querySelector(`#${trigger.getAttribute('aria-controls')}`);
				if (this.animationPanel) {
					triggerAccorditionPanel.style.height = `${0}px`;
					triggerAccorditionPanel.classList.add('hidden');
				}
				triggerAccorditionPanel.setAttribute('hidden', '');
				triggerAccorditionPanel.setAttribute('aria-hidden', 'true');
			}
		}
		this.allExpanded = false;
	}

	activateAccordionItem(item) {
		this.deactivateAll();

		item.setAttribute('aria-expanded', 'true');

		const targetAccordionPanel = this.accordion.querySelector(`#${item.getAttribute('aria-controls')}`);
		if (this.animationPanel) {
			targetAccordionPanel.style.height = `${targetAccordionPanel.scrollHeight}px`;
			targetAccordionPanel.classList.remove('hidden');
		}
		targetAccordionPanel.removeAttribute('hidden');
		targetAccordionPanel.removeAttribute('aria-hidden');

		if (targetAccordionPanel.querySelector('.gallery-carousel')) {
			const gCarouselEls = targetAccordionPanel.querySelector('.gallery-carousel');
			const gCarouselFlickity = Flickity.data(gCarouselEls);
			gCarouselFlickity.resize();
		}

		if (!this.allowToggle) {
			item.setAttribute('aria-disabled', 'true');
		}
	}

	// eslint-disable-next-line class-methods-use-this
	handleCloseClick(event) {
		event.preventDefault();
		event.stopPropagation();

		const target = event.currentTarget;
		const panelEl = target.closest('.accordion-item');
		panelEl.querySelector('.accordion-trigger').click();
	}
}

const opentimeAccordions = document.querySelectorAll('.opentime-accordion');
for (const accordionElem of opentimeAccordions) {
	const accordion = new Accordion(accordionElem);
	accordion.init();
	if (window.matchMedia('(min-width: 768px)').matches) {
		accordion.expandedAll();
	}
}

const generalAccordions = document.querySelectorAll('.general-accordion');
for (const accordionElem of generalAccordions) {
	const accordion = new Accordion(accordionElem);
	accordion.init();
}

export { Accordion };
